import React, { useEffect, useState } from 'react'
import { BrowserRouter  } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import Header from './components/Header'
import Footer from './components/Footer'
import Loading from './components/Loading'
import Error from './components/Error'

import { Offer } from './pages/Offer'
import { SET_DEALER } from './features/dealer/actionTypes'
import { Routes, baseName, ApiResult } from './types.d'
import { getDealerInfo } from './api'
import { IOpeningHours } from './features/dealer/types'
import { actionTypes as dealerActionTypes } from './features/dealer'
import { IError, IErrorButton } from './features/error/types'
import { actionTypes as errorActionTypes } from './features/error'

const EmailApp: React.FC = () => {
  const dispatch = useDispatch();
  const [hasSetDealer, setHasSetDealer] = useState(false);

	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());
	const oid: string = params.oid || '';

  useEffect(() => {
    if (!hasSetDealer){
      setHasSetDealer(true);
      dispatch({type: SET_DEALER, payload: {
        dealerID: (window as any).StoreWebsiteInfo.DealerID,
        stockDealerID: (window as any).StoreWebsiteInfo.StockDealerID, 
        dealerName: (window as any).StoreWebsiteInfo.DealerName,
        locationName: (window as any).StoreWebsiteInfo.LocationName
      }});
			getDealer();
    }
  });

	const getDealer = async () => {
    const traffic:ApiResult<any> = await getDealerInfo((window as any).StoreWebsiteInfo.DealerID);
    if (!traffic.errormessage && traffic.result){
      const d: Array<any> = traffic.result.DealerSites.length > 1 ? traffic.result.DealerSites.filter((d: any) => d.IsPrincipal) : traffic.result.DealerSites.length ? traffic.result.DealerSites[0] : [];
      if (!d.length) return null;
      const ds = d[0];
      const phone = ds.Phone;
      const address = `${ds.Address} ${ds.Suburb} ${ds.State} ${ds.Postcode}`;
      const website = ds.Website;
      const terms = traffic.result.Terms;
      let openingHours: Array<IOpeningHours> = [];
      try {
        openingHours = JSON.parse(ds.SalesOperatingHours);
      }
      catch {
        console.log('error parsing opening hours.');
      }
      
      dispatch({type: dealerActionTypes.SET_DEALER, payload: {
        privacyPolicy: traffic.result.PrivacyPolicy, 
        phone, 
        address, 
        website, 
        terms,
        openingHours
      }});
    }
    else {
      const btns: Array<IErrorButton> = [
        {
          title: 'Try again', 
          classes: 'button-solid', 
          callback: () => getDealer(), 
          clearErrorOnClick: true
        }, 
        {
          title: 'Back to registration', 
          classes: 'button-outline', 
          callback: () => { location.pathname = Routes.Specs }, 
          clearErrorOnClick: false
        }
      ]
      const err: IError = { 
        icon: require('./assets/images/exclamation.svg'),
        title: 'Sorry, we seem to be experiencing some technical difficulties, please try again later.', 
        buttons: btns
      };
      dispatch({ type: errorActionTypes.SET_ERROR, payload: err });
    }
  };

  return (
		<BrowserRouter basename={baseName}>
      <div className="i-wrapper">
        <Header />
        <main className="i-main">
					{oid ? 
            <Offer oid={oid} />
					: null}
        </main>
        <Footer />
        <Loading />
        <Error />
      </div>
		</BrowserRouter>
  )
}

export default EmailApp
